import { EntityWithStatusService } from './EntityWithStatusService';
import { IApp04Topic, IEntityChildren, IEntityDescription1 } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class App04TopicService extends EntityWithStatusService<IApp04Topic> {
    protected childrenEntities = ['App04TopicUsers($expand=User)'];

    constructor() {
        super(`/App04Topics`);
    }

    public readAllForList(includeClosed?: boolean, appID?: number): Promise<IApp04Topic[]> {
        return this.readAll(
            `?$select=ID,Title,AppID,WebSearch,WebSearchSites,CreatedOn,UpdatedOn`
            + `&$orderby=Title`
            + `&$expand=`
            + `App04TopicUsers($select=ID,UserID;$expand=User($select=Title))`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
            + (appID ? ` and AppID eq ${appID}` : ``)
        );
    }

    public readAllForLookup(includeClosedEntities?: boolean, additionalFields?: string): Promise<IApp04Topic[]> {
        return this.readAll(
            `?$select=ID,Title${additionalFields ? `,${additionalFields}` : ''}`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosedEntities ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public async readTitleForTopic(entityPlural: string, entitySingular: string, topicID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            DescriptionLine1: '',
            DescriptionLine2: '',
            Description1ForList: '',
            Description1ForForm: ''
        };
        const res = await this.readAll(`?$filter=ID eq ${topicID}&$select=Title`);

        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for topic`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for topic <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for topic <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        return this.entityChildrenSingle(id, 'Chats', 'App04AIChats', true);
    }
}